import React, { useState } from 'react';
import AppointmentBanner from '../AppointmentBanner/AppointmentBanner';
import AvailavelAppointment from '../AvailavelAppintment/AvailavelAppointment';

const MainAppointment = () => {
    const [selectedDate,setSelectedDate]=useState(new Date())
    return (
        <div>
            <AppointmentBanner
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            ></AppointmentBanner>

            <AvailavelAppointment
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            ></AvailavelAppointment>
        </div>
    );
};

export default MainAppointment;